import { render, staticRenderFns } from "./filterSlider.vue?vue&type=template&id=527c4f11&scoped=true&"
import script from "./filterSlider.vue?vue&type=script&lang=js&"
export * from "./filterSlider.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/ui.css?vue&type=style&index=0&id=527c4f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c4f11",
  null
  
)

export default component.exports